import type { AddonSku } from '@/services/billing/addon-change';
import { formatAddonPriceCents } from '../utils/addon-purchase';
import { useAddons } from './use-addons';

type AddonsList = NonNullable<ReturnType<typeof useAddons>['data']>;

/** The catalog price of `sku` in cents: what the account would pay to add it, or `null` when the list does not offer it. */
export function catalogPriceCents(addons: AddonsList | undefined, sku: AddonSku): number | null {
  return addons?.available.find((addon) => addon.product === sku)?.price ?? null;
}

/** The segments add-on's catalog price ("$10"), or `null` until the add-ons list loads or when it fails. */
export function useSegmentsAddonPrice(): string | null {
  const { data: addons } = useAddons();
  const cents = catalogPriceCents(addons, 'data_driven_segments');
  return cents == null ? null : formatAddonPriceCents(cents);
}
